import React from 'react'
import i18n from 'i18next'
import LicenseComponent from './LicenseComponent'
import Headline from '#components/a/Headline'
import licensesJson from './licenses.json'

function LicensesPage() {
  return (
    <section className="licenses-page">
      <Headline importance={1} modifier="section" text={i18n.t('licenses')} />
      <LicenseComponent licensesJson={licensesJson} />
    </section>
  )
}

export default LicensesPage
